import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '订单编号',
      prop: 'orderNumber'
    },
    {
      label: '订单日期',
      prop: 'createTime'
    },
    // {
    //   label: '主办方',
    //   prop: 'orgName'
    // },
    {
      label: '比赛名称',
      prop: 'busName'
    },
    {
      label: '比赛ID',
      prop: 'busId'
    },
    {
        label: '姓名',
        prop: 'orderUserName'
    },
    {
        label: '账号',
        prop: 'account'
    },
    {
        label: '支付金额',
        prop: 'payAmount'
    },
    {
        label: '退款比例',
        prop: 'refundScale'
    },
    {
        label: '退款金额',
        prop: 'refundAmount'
    },
    {
        label: '状态',
        prop: 'payStatus'
    }
  ]
}
